const inputFilesLabelNew = {
  text: 'Anexe os arquivos aqui'
};

export default inputFilesLabelNew;
